import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, switchMap, flatMap, catchError } from 'rxjs/operators';

import * as PayrollItemEmployeeActions from './payroll-item-employee.actions';
import { PayrollItemService } from '../payroll-item.service';
import { DisplayMessageMinimum } from '../../../shared';
import * as fromShared from '../../../shared';

@Injectable()
export class PayrollItemEmployeeEffects {
    constructor(
        private actions$: Actions,
        private service: PayrollItemService
    ) {}

    getPayrollItems$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(PayrollItemEmployeeActions.getPayrollItemEmployees),
            switchMap(action =>
                this.service.getEmployees(action.PIListID).pipe(
                    flatMap(resp => [
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        r =>
                                            r.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        ),
                        PayrollItemEmployeeActions.loadPayrollItemEmployees({
                            payrollItemEmployees: resp
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
}
